import React from 'react';
import { EligibleWithCondition } from "../../../CEF/Common/Constants";
import Button from "../../../CEF/Common/FooterButton";
import DialogWithCloseButton from "../../../CEF/Common/DialogWithCloseButton";
import DialogContent from "../../../CEF/Common/DialogWithCloseButton/DialogContent";
var EligibleWithConditionDialog = function EligibleWithConditionDialog(props) {
  var open = props.open,
    onClose = props.onClose,
    onApply = props.onApply,
    eligibilityConditionInfo = props.eligibilityConditionInfo;
  return /*#__PURE__*/React.createElement(DialogWithCloseButton, {
    open: open,
    onClose: onClose,
    dialogContent: /*#__PURE__*/React.createElement(DialogContent, {
      title: EligibleWithCondition,
      description: eligibilityConditionInfo
    }),
    dialogActions: /*#__PURE__*/React.createElement(Button, {
      label: "Apply Now",
      onClick: onApply
    })
  });
};
export default EligibleWithConditionDialog;